export const headerList = [
	{
		id: "home",
		to: "/home",
		label: "Home",
		icon: "home",
		isActive: true,
		exact: true
	},
	{
		id: "progress",
		to: "/progress",
		label: "Progress",
		icon: "progress",
		isActive: false
	},
	{
		id: "nutrition",
		to: "/nutrition",
		label: "Nutrition",
		icon: "nutrition",
		isActive: false
	},
	{
		id: "fitness",
		to: "/fitness",
		label: "Fitness",
		icon: "fitness",
		isActive: false
	},
	{
		id: "shop",
		to: "https://shop.mediweightloss.com",
		label: "Shop",
		icon: "shop",
		isActive: false,
		isNewTab: true
	}
];

export const subHeaderList = {
	nutrition: [
		{
			id: "nutritionHome",
			to: "/nutrition",
			label: "Nutrition Home",
			icon: null,
			isActive: false,
			exact: true
		},
		{
			id: "nutritionJournal",
			to: "/nutrition/journal",
			label: "Journal",
			icon: null,
			isActive: false,
			actionButtons: [
				{
					label: "Add TO JOURNAL",
					icon: "icon-add-to-journal",
					click: "NutritionJournal.toggleAddToJournal",
					value: true
				}
			]
		},
		{
			id: "recipes",
			to: "/nutrition/recipes",
			label: "Recipes",
			icon: null,
			isActive: true,
			actionButtons: [
				{
					to: "/nutrition/recipes/add",
					label: "Add new",
					icon: "icon-plus"
				}
			]
		},
		{
			id: "myfood",
			to: "/nutrition/myfood",
			label: "My Food",
			icon: null,
			isActive: true,
			onlyUser: true,
			actionButtons: [
				{
					to: "/nutrition/myfood/add",
					label: "Add new",
					icon: "icon-plus",
				}
			]
		},
		{
			id: "nutritionResources",
			to: "/nutrition/resources",
			label: "Resources",
			icon: null,
			isActive: false
		},
		{
			id: "foodDatabase",
			to: "/nutrition/food-database",
			label: "Food Database",
			icon: null,
			isActive: false,
			onlyAdmin: true,
			actionButtons: [
				{
					to: "/nutrition/food-database/add",
					label: "Add new",
					icon: "icon-plus",
					onlyAdmin: true
				}
			]
		}
	],
	fitness: [
		{
			id: "fitnessHome",
			to: "/fitness",
			label: "Fitness Home",
			icon: null,
			isActive: false,
			exact: true
		},
		{
			id: "fitnessJournal",
			to: "/fitness/journal",
			label: "Journal",
			icon: null,
			isActive: false,
			actionButtons: [
				{
					label: "Add TO JOURNAL",
					icon: "icon-add-to-journal",
					click: "MyWorkout.toggleAddPlanPanel",
					value: true
				}
			]
		},
		{
			id: "myProgress",
			to: "/fitness/my-progress",
			label: "My Workout",
			icon: null,
			isActive: false,
			actionButtons: [
				{
					label: "Add Plans",
					icon: "icon-plus",
					className: "btn-primary-dark",
					click: "Exercises.toggleAddExercisePanel",
					value: true
				},
				{
					label: "Add Exercises",
					icon: "icon-plus",
					click: "MyWorkout.toggleAddPlanPanel",
					value: true
				}
			]
		},
		{
			id: "workoutPlans",
			to: "/fitness/workout-plans",
			label: "Workout Plans",
			icon: null,
			isActive: false
		},
		{
			id: "exercises",
			to: "/fitness/exercises",
			label: "Exercises ",
			icon: null,
			isActive: false
		}
	]
};
